// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-noMargin-text-63550b20"};